import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Input from "../../../../../../../components/textbox/Input";
import styles from "../../../../DatiSpecifici/DatiSpecifici.module.css";
import Utils from "../../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json"

class DatiDelCompilatoreTubercolosi extends Component {

    state = {
        datiDelCompilatore: {
            nome: "",
            cognome: "",
            recapitoTelefonico: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.createOggettoBE = this.createOggettoBE.bind(this)
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiCompilatore) {
            let datiDelCompilatore = this.state.datiDelCompilatore
            let datiDelCompilatoreProps = this.props.segnalazioneCopia.schedaSpeciale.datiCompilatore

            datiDelCompilatore.nome = datiDelCompilatoreProps.nome ? datiDelCompilatoreProps.nome : this.state.datiDelCompilatore.nome
            datiDelCompilatore.cognome = datiDelCompilatoreProps.cognome ? datiDelCompilatoreProps.cognome : this.state.datiDelCompilatore.cognome
            datiDelCompilatore.recapitoTelefonico = datiDelCompilatoreProps.recapitoTelefonico ? datiDelCompilatoreProps.recapitoTelefonico : this.state.datiDelCompilatore.recapitoTelefonico

            this.setState({datiDelCompilatore: datiDelCompilatore});
            let oggetto = this.createOggettoBE()
            this.props.setDatiCompilatoreTubercolosi(this.state.datiDelCompilatore, oggetto)
        } else {
            let oggetto = this.createOggettoBE()
            this.props.setDatiCompilatoreTubercolosi(this.state.datiDelCompilatore, oggetto)
        }
    }

    riceviValore(field, event) {
        let datiDelCompilatore = this.state.datiDelCompilatore
        datiDelCompilatore[field] = event.target.value
        this.setState({datiDelCompilatore: datiDelCompilatore})
        let oggetto = this.createOggettoBE()
        this.props.setDatiCompilatoreTubercolosi(this.state.datiDelCompilatore, oggetto)
    }

    createOggettoBE() {
        let datiDelCompilatore = JSON.parse(JSON.stringify(this.state.datiDelCompilatore))
        let datiDelCompilatoreBe = Utils.removeEmptyValueFromObject(datiDelCompilatore)
        return Utils.removeFieldFromObject(datiDelCompilatoreBe, "corretto")
    }

    render() {
        const {t} = this.props

        const datiDelCompilatore = (
            <div className={"container"}>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                            {t("SchedaSpecialeTubercolosi.cognome")}
                        </p>
                        <Input id={"cognome"}
                            onChange={this.riceviValore}
                            field={"cognome"}
                            value={this.state.datiDelCompilatore.cognome}
                            placeholder={t("SchedaSpecialeTubercolosi.cognome")}
                        />
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                            {t("SchedaSpecialeTubercolosi.nome")}
                        </p>
                        <Input id={"nome"}
                            onChange={this.riceviValore}
                            field={"nome"}
                            value={this.state.datiDelCompilatore.nome}
                            placeholder={t("SchedaSpecialeTubercolosi.nome")}
                        />
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                            {t("SchedaSpecialeTubercolosi.recapitoTelefonico")}
                        </p>
                        <Input id={"recapitoTelefonico"}
                            onChange={this.riceviValore}
                            field={"recapitoTelefonico"}
                            value={this.state.datiDelCompilatore.recapitoTelefonico}
                            placeholder={t("SchedaSpecialeTubercolosi.recapitoTelefonico")}
                        />
                    </div>
                </div>
            </div>
        )

        return (
            <div>
                <h6>{t("SchedaSpecialeTubercolosi.datiDelCompilatore")}</h6>
                <hr className={styles.hr}/>
                {datiDelCompilatore}
            </div>)
    }

}

export default withTranslation('common')(DatiDelCompilatoreTubercolosi)
